(function (ws) {
    'use strict';

    ws.views.rfqShipping = ws.views.shipping.extend({

        showSaveAlert: true,

        events: _.extend({}, ws.views.shipping.prototype.events, {
            'click .qut-clear-button': 'confirmClear',
            'click .qut-save': 'saveForm',
            'click .qut-submit-button': 'disableAlertSubmit',
            'change #country': 'onCountryChange',
            'change #addressBook': 'onSelectAddressBookChanged',
            'click .createNewAddress-shipto': 'newShipToCreation'
        }),

        newShipToCreation: function () {
            this.eventAgg.trigger('shipToAccountLookupModal');
            this.eventAgg.trigger('selectingFromLink');
        },

        avoidTriggeringInternalSearchRfq: function () {
            this.triggerPopupdisabled = true;
        },

        addAddress: function () {
            if (this.triggerPopupdisabled) {
                this.triggerPopupdisabled = false;
                return;
            }

            this.eventAgg.trigger('shipToAccountLookupModal');
        },

        /**
         * Initialize override
         */
        initialize: function () {
            ws.views.shipping.prototype.initialize.call(this);
            this.triggerPopupdisabled = false;
            this.shippingMdmVerified = false;
            this.confirmModalId = this.$('.qut-clear-button').data('modalonconfirmation');
            this.eventAgg.on(this.confirmModalId + 'continue', this.clearQuote, this);
            this.$saveBtn = this.$('.qut-save');
            this.render();
            this.hasChanged = true;
            this.$endUserContainer = this.$('.qut-end-user');
            this.$endUserSelect = this.$('select#endUser');
            this.$endUserInput = this.$('input#newEndUser');
            this.$saveEndUserCheckbox = this.$('#saveEndUser');
            this.$selectAddressBook = this.$('#selectFromAddress');
            this.$generalError = this.$('.generalError');
            this.addressValidationEnabled = $('#enableAddressValidation').val() === 'true' ? true : false;

            this.$shippingAddressForm = $('form#quoteConfirmationData');
            this.shippingAddressModel = new ws.models.shippingAddressMdmValidation();

            // Firefox doesn't recognise delegated events for disabled fieldset elements, so binding them directly
            this.$('[name="endUserAction"]').on('change', this.onEndUserActionChanged.bind(this));
            this.eventAgg.on('settingUpShippingAddressByMDM', this.settingUpShippingAddressByMDM.bind(this));
            this.eventAgg.on('avoidTriggeringInternalSearchRfq', this.avoidTriggeringInternalSearchRfq.bind(this));

            if ($('#enableMDMTrilliumAddressValidation').val() === 'true') {
                setTimeout(()=> {
                    $('#newAddress').on('change', () => {
                        this.addAddress();
                    });

                    this.newAddressCreateLinkTogle();
                }, 2000);
            }

            this.openPageAlert();
            this.onCountryChange();
        },

        newAddressCreateLinkTogle: function () {
            if ($('.shipping-section #newAddress').prop('checked')) {
                $(`.shipping-section`).find('.createAddressLink').removeClass('hide');
            }
        },

        /**
         * Update Shipping Address from mdm response
         * @param {Object} account - Accrount Details
         */
        settingUpShippingAddressByMDM: function(account, isReformatted) {
            this.$('.comp-rfq-shipping #companyName').val(isReformatted ? account.accountName : account.get('accountName'));
            this.$('.comp-rfq-shipping #line1').val(isReformatted ? account.addressLine1 : account.get('addressLine1'));
            this.$('.comp-rfq-shipping #line2').val(isReformatted ? account.addressLine2 : account.get('addressLine2'));
            this.$('.comp-rfq-shipping #line3').val(isReformatted ? account.addressLine3 : account.get('addressLine3'));
            this.$('.comp-rfq-shipping #line4').val(isReformatted ? account.addressLine4 : account.get('addressLine4'));
            this.$('.comp-rfq-shipping #locality').val(isReformatted ? account.locality : account.get('locality'));
            this.$('.comp-rfq-shipping #city').val(isReformatted ? account.town : account.get('town'));
            this.$('.comp-rfq-shipping #phone').val(isReformatted ? account.phone : account.get('phone'));
            this.$('.comp-rfq-shipping #zipCode').val(isReformatted ? account.zipCode : account.get('zipCode'));
            this.$('.comp-rfq-shipping #state').val(isReformatted ? account.country.isocode + '-' + account.state : account.get('country').isocode + '-' + account.get('state'));
            this.$('#selectedAddressId').val(isReformatted ? '' : (account.get('sapId') === '0000000000' ? '' : account.get('sapId')));

            //this.trackingQuoteSubmit();
            // trigger form submit call
            this.eventAgg.trigger('checkErrorAndSubmitFromStore');
        },

        /**
         * When country changes we need to update state list based on selected country
         */
        onCountryChange: function () {
            if (this.countries) {
                this.updateFieldsWithCountry(this.countries);
            } else {
                this.countries = new ws.models.shippingCountry();
                this.countries.fetch({
                    success: (response) => {
                        this.updateFieldsWithCountry(response);
                    }
                });
            }
        },

        /**
         * Handle changed endUser entry fieldset trigger
         * @param {Event} ev - Event object
         */
        onEndUserActionChanged: function (ev) {
            switch (ev.target.id) {
                case 'endUserAction':
                    this.$saveEndUserCheckbox.prop('checked', false);
                    this.$saveEndUserCheckbox.prop('disabled', true);
                    this.$endUserSelect.prop('disabled', false);
                    this.$endUserInput.prop('disabled', true);
                    break;

                case 'createNew':
                    this.$endUserSelect.prop('selectedIndex', 0);
                    this.$endUserSelect.trigger('change.select2');
                    this.$endUserSelect.prop('disabled', true);
                    this.$endUserInput.prop('disabled', false);
                    this.$saveEndUserCheckbox.prop('disabled', false);
                    break;
            }

            this.clearAllInputs(this.$endUserContainer.find('input[type=text], select'));

        },

        /**
         * Populate address fields if user selects address from address book
         * @param {Object} ev - Event object provided by the browser
         */
        onSelectAddressBookChanged: function (ev) {
            var $container = $(ev.currentTarget).parents('.comp-shipping');
            var $addressBookList = $container.find('#addressBook');
            var $newAddressCountryList = $container.find('#newAddressContainer #country');
            this.$addressTypeFieldsets = $container.find('.address-type-fieldset');

            this.$('#addressBookId').val($addressBookList.val());
            let isMdmVerified = $addressBookList.find('option:selected').data('mdm-verified') === true || $addressBookList.find('option:selected').data('mdm-verified') === 'true' ? true : false;

            if ($addressBookList.val()) {
                if (isMdmVerified && this.addressValidationEnabled) {
                    $container.find('.newAddress-fieldset').prop('disabled', true);
                    $container.find('.newAddress-fieldset').find('select').prop('disabled', true);
                } else {
                    $container.find('.newAddress-fieldset').prop('disabled', false);
                    $container.find('.newAddress-fieldset').find('select').prop('disabled', false);
                }

                this.$addressTypeFieldsets.find('#saveToAddressBook').prop('disabled', true).val('false');
                this.$addressTypeFieldsets.find('#saveToAddressBook').parent().addClass('hide');

                var addressData = $addressBookList.find('option:selected').data('attr');
                var country = _.findWhere(addressData, {name: 'country'});

                this.shippingMdmVerified = isMdmVerified;
                $('#mdmVerified').val(isMdmVerified);

                // When Address Book has a value, show pre-filed fields to show details address.
                this.$newAddressContainer.show();

                // If country is not the currently selected country,
                // then it needs to fetch and update the list of states.
                if (country.value !== $newAddressCountryList.val()) {
                    this.fetchStates = $.Deferred();
                    $newAddressCountryList.val(country.value).trigger('change');
                    this.fetchStates.done(function () {
                        this.updateInputsWithAddressBookData(addressData, $container, 'shipping');
                    }.bind(this));
                } else {
                    this.updateInputsWithAddressBookData(addressData, $container, 'shipping');
                }
            } else {
                this.$addressTypeFieldsets.find('#saveToAddressBook').parent().removeClass('hide');
                this.$addressTypeFieldsets.find('#saveToAddressBook').prop('disabled', false).val('true');
                this.shippingMdmVerified = false;
                $('#mdmVerified').val(false);
            }
        },

        /**
         * Clear all the values in the list of inputs provided.
         * @param {NodeList} $elementList - List of input type elements
         */
        clearAllInputs: function ($elementList) {
            _.each($elementList, function (element) {
                if ($(element).tagName === 'SELECT') {
                    $(element).val('');
                    $(element).trigger('change');
                } else {
                    $(element).val('');
                }

            });
        },

        /**
         * Launch Confirm Clear Quote Modal
         * @param {Object} e
         */
        confirmClear: function (e) {
            e.preventDefault();
            this.eventAgg.trigger(this.confirmModalId);
        },

        /**
         * Clear Quote
         */
        clearQuote: function () {
            this.$('.qut-clear-form').submit();
        },

        /**
         * Disable Alert message when submit
         */
        disableAlertSubmit: function () {
            this.hasChanged = false;
        },

        /**
         * Additional field validations
         */
        additionalValidation: function() {
            if (this.$selectAddressBook.is(':checked')) {
                this.error = false;
            } else if (this.allEmptyOptionalFields()) {
                //if every optional field is empty, there is no need to validate.
                this.error = false;
            } else {
                //if one or more of the optional fields have a value, then the user is required to fill in the rest of them except for state and postal code fields.
                const $optionalFields = this.$('input.optional:visible:not("#zipCode"), select.optional:visible:not("#state"), textarea.optional:visible, checkbox.optional:visible');
                this.checkEmptyFields($optionalFields);
                this.checkPhone();
            }

            if (this.error === false) {
                if (this.addressValidationEnabled && (this.shippingMdmVerified === 'false' || this.shippingMdmVerified === false) && $('#enableMDMTrilliumAddressValidation').val() === 'false') {
                    globals.disableApp();

                    $('#mdmVerified').val(true);
                    $('#mDMAddress').val(true);
                    this.mdmFormValidation();
                } else {
                    this.updateValues();

                    //this.trackingQuoteSubmit();
                    $('#mDMAddress').val(false);
                }
            }
        },

        /**
         * MDM Address validation
         */
        mdmFormValidation: function () {
            this.error = true;
            globals.disableApp();
            var formData = {};
            this.$shippingAddressForm.find('input[type="text"]').each(function() {
                var $this = $(this);
                formData[$this.attr('name')] = $this.val().trim();
            });

            this.$shippingAddressForm.find('input[type="radio"]').each(function() {
                var $this = $(this);
                formData[$this.attr('name')] = $this.val();
            });

            this.$shippingAddressForm.find('select').each(function() {
                var $this = $(this);
                formData[$this.attr('name')] = $this.val();
            });

            var shippingAddress = {
                addressAction: formData.endUserAction,
                shippingAddress: {
                    companyName: formData['shippingAddress.companyName'],
                    line1: formData['shippingAddress.line1'],
                    line2: formData['shippingAddress.line2'],
                    line3: formData['shippingAddress.line3'],
                    line4: formData['shippingAddress.line4'],
                    locality: formData['shippingAddress.locality'],
                    phone: formData['shippingAddress.phone'],
                    postalCode: formData['shippingAddress.postalCode'],
                    town: formData['shippingAddress.town'],
                    region: {
                        isocode: formData['shippingAddress.region.isocode']
                    },
                    country: {
                        isocode: formData['shippingAddress.country.isocode']
                    }
                }
            };

            this.$shippingAddressForm.find('input[type="submit"]').attr('disabled', true);
            globals.disableApp();
            this.shippingAddressModel.save(shippingAddress)
                .done(function (data) {
                    this.$shippingAddressForm.find('input[type="submit"]').removeAttr('disabled');
                    this.shippingAddressModel.isMdmValidated = true;
                    if (data.error) {
                        var html = '<ul>';
                        _.each(data.errors, function (error) {
                            html += '<li>' + error.message + '</li>';
                        });
                        html += '</ul>';
                        this.$generalError.html(html);
                        this.$generalError.show();
                        $('html, body').animate({
                            scrollTop: $('.generalError:visible:first').offset().top - 200
                        }, 700);
                        globals.enableApp();
                    } else {
                        this.updateValues();
                        this.$generalError.html('');
                        this.$generalError.hide();
                        if (data.suggested.length > 0) {
                            this.eventAgg.trigger('storeAccountAddAddress', data, 'shipping');
                        } else {
                            this.settingUpShippingAddressByMDM(data.reformatted, true);
                        }

                        globals.enableApp();
                        $('.address-id').removeClass('highlightCell');
                    }
                }.bind(this))
                .fail(function (resp) {
                    globals.enableApp();
                    console.error('Could not add new address: ', resp);
                }.bind(this));

        },

        /**
         * Update values
         */
        updateValues: function () {
            if (!this.error) {
                $('#addressBook').val('null');
            }
        },

        /**
         * Tracking Quote Details while submission from RFQ page
         *
         */
        trackingQuoteSubmit: function() {
            this.eventDataLayer = {};
            this.eventDataLayer.event = this.GTM_EVENT_NAME;
            this.eventDataLayer.eventCategory = 'quote_request';
            this.eventDataLayer.eventAction = 'submit_quote';
            this.eventDataLayer.quoteID = this.$('#rfqID').val();
            this.eventDataLayer.vertical = this.$('#verticalMarket').val();
            this.eventDataLayer.user = this.$('input[name="endUserAction"]:checked').val();
            this.eventDataLayer.shipping = this.$('input[name="addressAction"]:checked').val();
            this.logGTMEvent();

            dataLayerAA.funnel = {};
            dataLayerAA.funnel.step = '1';
            dataLayerAA.funnel.stepName = 'completion';
            dataLayerAA.funnel.type = 'create quote';
            dataLayerAA.funnel.completion = '1';
            dataLayerAA.quote = {};
            dataLayerAA.quote.id = this.$('#rfqID').val();
            _satellite.track('event:quote:confirmation');
        },

        /**
         * Save form
         * @param {Event} ev - Event object
         */
        saveForm: function (ev) {
            ev.preventDefault();
            this.hasChanged = false;
            this.$el.prop('action', $(ev.currentTarget).data('url'));
            this.$saveBtn.addClass('spinner-before no-padding');
            this.$saveBtn.css('margin-left', '33px');
            this.$saveBtn.prop('disabled', true);

            this.checkDate();

            if (this.error === true) {
                this.hasError();

                // If something went wrong the Save button should be enabled.
                this.$saveBtn.removeClass('spinner-before no-padding');
                this.$saveBtn.css('margin-left', 'auto');
                this.$saveBtn.prop('disabled', false);

                // Reset the error state.
                this.error = false;
            } else {
                if ($('#addressBook').val() !== null) {
                    this.$('#addressBook').val('null');
                    this.$('#selectFromAddress').val('createNew');
                }

                _satellite.track('event:saveQuote');
                this.$el.submit();
            }
        }

    });

}(westcon));
